const FOREGROUND_COLOR = '#FFFFFF';
const DEFAULT_TEXT_COLOR = '#2d4150';
const SECONDARY_TEXT_COLOR = '#4caf50';
const DISABLED_COLOR = '#d9e1e8';

export const textDayFontFamily = 'System';
export const textMonthFontFamily = 'System';
export const textDayHeaderFontFamily = 'System';
export const todayButtonFontFamily = 'System';

export const textDayFontWeight = '300';
export const textMonthFontWeight = '300';
export const textDayHeaderFontWeight = undefined;
export const todayButtonFontWeight = '600';

export const textDayFontSize = 16;
export const textMonthFontSize = 16;
export const textDayHeaderFontSize = 13;
export const todayButtonFontSize = 14;

export const textDayStyle = undefined;
export const arrowStyle = undefined;
export const arrowWidth = 14;
export const arrowHeight = 16;

export const calendarBackground = FOREGROUND_COLOR;
export const textSectionTitleColor = '#b6c1cd';
export const textSectionTitleDisabledColor = DISABLED_COLOR;
export const selectedDayBackgroundColor = SECONDARY_TEXT_COLOR;
export const selectedDayTextColor = FOREGROUND_COLOR;
export const todayBackgroundColor = undefined;
export const todayTextColor = SECONDARY_TEXT_COLOR;
export const dayTextColor = DEFAULT_TEXT_COLOR;
export const textDisabledColor = DISABLED_COLOR;
export const textInactiveColor = DISABLED_COLOR;
export const arrowColor = SECONDARY_TEXT_COLOR;
export const disabledArrowColor = DISABLED_COLOR;
export const titleTextColor = DEFAULT_TEXT_COLOR;
export const todayButtonTextColor = SECONDARY_TEXT_COLOR;
export const todayButtonPosition = undefined;
export const headerBackgroundColor = FOREGROUND_COLOR;

export const switchButtonColor = SECONDARY_TEXT_COLOR;
export const localsDropdownBackgroundColor = FOREGROUND_COLOR;
export const weekVerticalMargin = 7;
